<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    export default {
        name: 'fedex-validation',
        created: function () {
            Event.$on(this.fedex.listener, this.onHandleFedexResult);
        },
        beforeDestroy: function () {
            Event.$off(this.fedex.listener, this.onHandleFedexResult);
        },
        data: function () {
            return {
                fedex: { // defaults
                    event: 'validateAddress',
                    listener: 'handleFedexResult',
                    container: 'address', // in data
                    isValidated: false,
                    errorMessage: ''
                }
            };
        },
        computed: {
            isAddressUnresolved: function () {
                return !this.fedex.isValidated;
            }
        },
        methods: {
            onHandleFedexResult: function (data) {
                const isValidated = data.success || false;
                if (isValidated) {
                    this.fedex.errorMessage = '';
                    if ('address' in data) {
                        // this.$data or this.$props ?
                        Object.assign(this[this.fedex.container], data.address);
                    }
                } else if ('message' in data) {
                    this.fedex.errorMessage = data.message || 'The address provided failed to resolve.';
                } else {
                    this.fedex.errorMessage = '';
                }
                this.fedex.isValidated = isValidated; // fedex.container is already updated at the moment
            },
            onFedexFieldBlur: function (field) {
                Event.$emit(this.fedex.event, Object.assign(
                    // container can reside in this.$props as well as in this.$data
                    {}, this[this.fedex.container], { callback: this.fedex.listener }
                ));
            }
        }
    }
</script>


// WEBPACK FOOTER //
// fedex-validation.vue?0a9c79dc